import React, { Component } from 'react';
import "../../../../../style/registerPage.css"
import BuildingContext from "../../../../../contexts/Building";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import {BsPersonCircle} from "react-icons/bs";
import {FormControl, MenuItem, Select} from "@mui/material";
import { searchResidentHosts } from '../../../../../utils/hostResidentSearch';

class FGInformationFamilyPage extends Component {
    static contextType = BuildingContext;

    state = {
        peopleFound: [],
        searchInput: "",
        selectedPeople: "",
        searchType: "fullName",
        listLoading: true,
    }

    componentDidMount() {
        this.loadHosts('');
    }

    loadHosts = async (querySuffix = '') => {
        this.setState({listLoading: true});
        const peopleFound = await searchResidentHosts(querySuffix);
        this.setState({peopleFound, listLoading: false});
    }

    handleSearchInput = (e) => {
        const value = e.target.value;
        this.setState({searchInput: value});
        const q = (value || '').trim();
        if (!q) {
            this.loadHosts('');
            return;
        }
        this.loadHosts(`&${this.state.searchType}=${encodeURIComponent(q)}`);
    }

    handleChange = (event, newAlignment) => {
        if (!newAlignment) {
            return;
        }
        this.setState({selectedPeople: newAlignment});
        this.context.handleFields(newAlignment, 'familyGuestInformationFamily', 'hostId');
    }

    render() {
        const {peopleFound, listLoading} = this.state;
        return (
            <>
                <div className="register-step-box">
                    <h2>انتخاب ميزبان</h2>
                    <div className="search-box d-flex justify-content-center">
                        <div className="form-floating">
                            <FormControl className={"w-100"}>
                                <Select
                                    sx={{ height: 50, borderRadius: 2, minWidth: "10rem"}}
                                    id="select-field"
                                    value={this.state.searchType}
                                    onChange={(e) => {
                                        this.setState({searchType: e.target.value});
                                    }}>
                                    <MenuItem value={"fullName"}>نام و نام خانوادگی</MenuItem>
                                    <MenuItem value={"nationalCode"}>کد ملی</MenuItem>
                                </Select>
                                <label className="placeholder" style={{
                                    top: '-8px',
                                    backgroundColor: '#fff',
                                    color: '#2a2e32b3',
                                    margin: '-0.2rem 0.2rem',
                                    padding: '0 .4rem',
                                    opacity: '1',
                                }}>براساس</label>
                            </FormControl>
                        </div>
                        <input type="text"
                               id="inputSearch"
                               placeholder="جسـتجـو..."
                               value={this.state.searchInput}
                               onChange={this.handleSearchInput}/>
                        <div className="search-icon"><i className="bi bi-search"></i></div>
                    </div>
                    <div className="people-container mt-4">
                        {listLoading ? (
                            <p className="text-muted text-center">در حال بارگذاری اقامتگران ثابت…</p>
                        ) : peopleFound.length === 0 ? (
                            <p className="text-muted text-center">اقامتگر ثابتی برای میزبان یافت نشد.</p>
                        ) : (
                            <ToggleButtonGroup
                                orientation="vertical"
                                value={this.state.selectedPeople}
                                exclusive
                                color="success"
                                onChange={this.handleChange}
                                aria-label="انتخاب میزبان"
                                style={{width: "100%"}}
                            >
                                {peopleFound.map((people) => (
                                    <ToggleButton
                                        key={people.parentId}
                                        value={people.parentId}
                                        style={{display: "block"}}
                                    >
                                        <div className="row">
                                            <div
                                                className="col-3 profile-img d-flex align-items-center justify-content-center">
                                                <BsPersonCircle fontSize="60px"/>
                                            </div>
                                            <div className="col-9 people-info row">
                                                <div className="col-6">
                                                    <div className="d-flex">
                                                        <label>نام و نام خانوادگی: </label>
                                                        <p>{people.fullName || `${people.firstName || ''} ${people.lastName || ''}`.trim()}</p>
                                                    </div>
                                                    <div className="d-flex">
                                                        <label>نام پدر: </label>
                                                        <p>{people.fatherName || '—'}</p>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="d-flex">
                                                        <label>کد ملی :</label>
                                                        <p>{people.nationalCode}</p>
                                                    </div>
                                                    <div className="d-flex">
                                                        <label>تاریخ پذیرش :</label>
                                                        <p>{people.timePeriod?.startDate?.split(' ')[0] || '—'}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ToggleButton>
                                ))}
                            </ToggleButtonGroup>
                        )}
                    </div>
                </div>
            </>
        );
    }
}

export default FGInformationFamilyPage;
